import styled from 'styled-components';
export var CardContent = styled.div.withConfig({
  displayName: "CardContent",
  componentId: "sc-1lumfzv-0"
})(["display:flex;position:relative;z-index:20;flex-flow:column;width:100%;padding:14px 12px;"]);